import React from 'react'

const Marquee = () => {
  const items = [
    'Clarify The Complex',
    'Automate The Simple',
    'Actionable Intelligence',
    'Forward Looking',
    'Outcome Driven',
  ]

  return (
    <div className="py-8 bg-black border-y border-gray-800 overflow-hidden marquee-container">
      <div className="relative w-full flex whitespace-nowrap overflow-hidden">
        <div className="animate-marquee flex gap-12 text-white/80 font-bold text-2xl uppercase tracking-widest items-center">
          {items.map((item, idx) => (
            <React.Fragment key={idx}>
              <span>{item}</span>
              <span className="text-blue-500 text-sm">•</span>
            </React.Fragment>
          ))}
          {/* Duplicate for seamless loop */}
          {items.map((item, idx) => (
            <React.Fragment key={`dup-${idx}`}>
              <span>{item}</span>
              <span className="text-blue-500 text-sm">•</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Marquee
